import React, { useEffect } from 'react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { Outlet, useMatch } from 'react-router-dom';
import { useAppSelector } from 'src/hooks/store';
import { selectInfoPopup } from 'src/store/ui/selectors';

import 'src/styles/index.scss';

import { isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';
import { AdBlockGate } from 'src/components/common/AdBlockGate';
import Head from 'src/components/common/Head';
import InfoPopup from 'src/components/common/InfoPopup';
import { ROOT } from 'src/constants/routes';
import { useResponsive } from 'src/hooks';
import { AppDispatch } from 'src/store';
import { getMainData } from 'src/store/data/actions';
import { selectParties, selectSeo, selectShares } from 'src/store/data/selectors';
import { theme } from 'src/theme';

import Header from '../Header';
import css from './PageLayout.module.scss';

const PageLayout = () => {
  const dispatch = useDispatch<AppDispatch>();
  const matchMain = useMatch(ROOT);
  const parties = useAppSelector(selectParties);
  const seo = useAppSelector(selectSeo);
  const shares = useAppSelector(selectShares);
  const [isMobile] = useResponsive(['MOBILE', 'TABLET_P']);
  const showInfoPopup = useAppSelector(selectInfoPopup);

  useEffect(() => {
    if (isEmpty(parties)) {
      dispatch(getMainData());
    }
  }, [dispatch, parties]);

  return (
    <AdBlockGate enabled={matchMain != null}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Head
          seo={{ title: seo.title, description: seo.subtitle }}
          og={{ title: shares.general.title, description: shares.general.subtitle, imageUrl: shares.general.imageUrl }}
        />
        {!isMobile && <Header />}
        <div className={css.content}>
          <div className={css.contentInner}>
            {isMobile && <Header />}
            <Outlet />
            {showInfoPopup && <InfoPopup />}
          </div>
        </div>
      </ThemeProvider>
    </AdBlockGate>
  );
};

export default PageLayout;
